import * as pdfjsLib from "pdfjs-dist";
pdfjsLib.GlobalWorkerOptions.workerSrc = "https://unpkg.com/pdfjs-dist@4.0.379/build/pdf.worker.min.mjs";

const cache = new Map();
const MAX = 3;
let running = 0;
const queue = [];
const slot = () => new Promise((res) => { if (running < MAX) { running += 1; res(); } else { queue.push(res); } });
const release = () => { const next = queue.shift(); if (next) { next(); } else { running -= 1; } };

// Prima pagina del PDF come immagine (anteprima senza barra del lettore PDF), max 3 in parallelo.
export const pdfFirstPageImage = (key, loadBlob) => {
  if (!cache.has(key)) {
    cache.set(key, (async () => {
      await slot();
      let pdf = null;
      try {
        const buf = await (await loadBlob()).arrayBuffer();
        pdf = await pdfjsLib.getDocument({ data: buf }).promise;
        const page = await pdf.getPage(1);
        const vp = page.getViewport({ scale: 1 });
        const v = page.getViewport({ scale: 420 / vp.width });
        const canvas = document.createElement("canvas");
        canvas.width = v.width; canvas.height = v.height;
        await page.render({ canvasContext: canvas.getContext("2d"), viewport: v }).promise;
        return canvas.toDataURL("image/jpeg", 0.7);
      } catch { cache.delete(key); return null; }
      finally { if (pdf) { pdf.destroy(); } release(); }
    })());
  }
  return cache.get(key);
};
